import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import { addMonths, eachDayOfInterval, format, isEqual, isSameMonth, lastDayOfMonth, lastDayOfWeek, startOfDay, startOfMonth, startOfWeek, subMonths } from "date-fns";
import { ChevronLeft, ChevronRight } from "mdi-material-ui";
import PropTypes from "prop-types";
import { useState } from "react";
import CalendarCell from '../CalendarCell';
import Popper from "../../../Popper";
import CreativesPopper from '../CreativesPopper';
const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
function MonthView(props) {
    var _a;
    const { schedule = [], mediaName, mediaOptionName, toolName, frequency, startDate, endDate } = props;
    const [month, setMonth] = useState(new Date((_a = schedule[0]) === null || _a === void 0 ? void 0 : _a.date));
    const [anchor, setAnchor] = useState(null);
    const [creativesPopperData, setCreativesPopperData] = useState({
        units: 1,
        date: "",
        artwork: [{ name: "", url: "" }]
    });
    let scheduleDays = {};
    schedule.forEach(ele => {
        scheduleDays[new Date(ele.date).toISOString()] = ele;
    });
    const weekRenderer = () => {
        return (_jsx(Box, Object.assign({ sx: {
                gridColumn: "1 / -1",
                display: "grid",
                gridTemplateColumns: "repeat(7, 1fr)",
                background: "#fff",
                margin: "10px 0px 0px",
                borderRadius: "5px"
            } }, { children: weekdays.map((weekday) => (_jsx(Typography, Object.assign({ variant: "h3", sx: { height: "40px", display: "grid", justifyContent: "right", alignItems: "center", borderWidth: "1.5px", borderStyle: "solid", borderColor: "border.light", paddingRight: "15px" } }, { children: weekday }), weekday))) })));
    };
    const handlePopperOpen = (ref, schedule) => {
        setAnchor(ref);
        setCreativesPopperData(schedule);
    };
    const renderDays = () => {
        const daysInMonth = eachDayOfInterval({
            start: startOfWeek(startOfMonth(month)),
            end: lastDayOfWeek(lastDayOfMonth(month)),
        });
        return daysInMonth.map((day, idx) => {
            let disabled = !isSameMonth(day, month);
            let isToday = isEqual(day, startOfDay(new Date()));
            let currentDaySchedule = scheduleDays[new Date(day).toISOString()];
            return _jsx(CalendarCell, { disabled: disabled, date: day, isToday: isToday, schedule: currentDaySchedule, mediaName: mediaName, mediaOptionName: mediaOptionName, showPopper: handlePopperOpen }, idx);
        });
    };
    const handlePopperClose = () => {
        setAnchor(null);
        setCreativesPopperData({ units: 1, date: "", artwork: [{ name: "", url: "" }] });
    };
    return (_jsxs(Box, Object.assign({ mt: 3, sx: { width: 'fit-content' } }, { children: [_jsx(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "center" }, { children: _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", gap: 3 }, { children: [_jsx(ChevronLeft, { sx: {
                                color: "#71797A",
                                fontSize: "20px",
                                cursor: "pointer"
                            }, onClick: () => setMonth(subMonths(month, 1)) }), _jsx(Box, Object.assign({ display: "flex", justifyContent: "center", sx: { width: "160px" } }, { children: _jsx(Typography, Object.assign({ variant: "h2", fontWeight: "fontWeightSemiBold" }, { children: format(month, "MMMM yyyy") })) })), _jsx(ChevronRight, { sx: {
                                color: "#71797A",
                                fontSize: "20px",
                                cursor: "pointer"
                            }, onClick: () => setMonth(addMonths(month, 1)) })] })) })), _jsxs(Box, Object.assign({ sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(7, 1fr)",
                    marginTop: "12px",
                    height: "fit-content"
                } }, { children: [weekRenderer(), renderDays()] })), anchor && _jsx(Popper, { anchorEl: anchor, content: _jsx(CreativesPopper, { schedule: creativesPopperData, mediaName: mediaName, mediaOptionName: mediaOptionName, toolName: toolName, frequency: frequency, startDate: startDate, endDate: endDate }), handleClose: handlePopperClose })] })));
}
MonthView.propTypes = {
    schedule: PropTypes.array,
    mediaName: PropTypes.string,
    mediaOptionName: PropTypes.string,
    toolName: PropTypes.string,
    frequency: PropTypes.string,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
};
export default MonthView;
